import { connectLiveLinks } from '../../containers/live-links-container.js';
import LiveLinks from './live-links.js';

export default connectLiveLinks(LiveLinks);
